import React from 'react'
import { ArrowLeft } from 'react-feather'
import { useLocation } from 'react-router-dom'
import { match } from 'ts-pattern'

import { InformationCard } from '@frame/ui-components/information-card'
import { SlideUpPopover } from '@frame/ui-components/slide-up-popover'
import { UnorderedList } from '@frame/ui-components/unordered-list'
import { Button } from '@frame/ui-primitives/button'
import { H3 } from '@frame/ui-primitives/h3'

import { useDocumentsFlowContext } from '@documents/contexts/documents-flow-context'
import { DocumentTypeOption } from '@documents/types'
import { getW2Year } from '@documents/v2/utils/getW2Year'

import { PaystubInfo } from './paystub-info'
import { W2Info } from './w2-info'

function MoreInfoCard({ onClick }: { onClick?: () => void }) {
  const location = useLocation()

  const { selectedDocumentType } = useDocumentsFlowContext()

  const selectedSupportedDocumentType = Boolean(location.state?.selectedSupportedDocumentType)

  if (!selectedSupportedDocumentType) return null

  const { w2Year } = getW2Year()

  return match(selectedDocumentType)
    .with(DocumentTypeOption.PAYSTUB_OR_W2, () => (
      <InformationCard onClick={onClick}>
        <UnorderedList items={['Paystubs must cover last 30 days', `W2s must cover ${w2Year}`]} />
      </InformationCard>
    ))
    .otherwise(() => null)
}

function MoreInfoPopover({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const { selectedDocumentType } = useDocumentsFlowContext()

  return match(selectedDocumentType)
    .with(DocumentTypeOption.PAYSTUB_OR_W2, () => (
      <SlideUpPopover show={isOpen} hide={onClose}>
        <div className="mb-4 flex items-center space-x-2">
          <Button aria-label="Back" onClick={onClose} Icon={ArrowLeft} border={false} intent="secondary" />
          <H3>Frequently asked questions</H3>
        </div>
        <div className="flex flex-col gap-3">
          <PaystubInfo />
          <W2Info />
        </div>
      </SlideUpPopover>
    ))
    .otherwise(() => null)
}

export { MoreInfoCard, MoreInfoPopover }
